/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }
Utility.HealthManager = class HealthManager {

  static sendTokenToServer(userId, token) {
    return $.ajax({
      url: "/health_manager/token",
      type: 'POST',
      data: {
        token: {
          user_id: userId,
          token
        }
      },
      headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
      },
      cache: false,
      dataType: 'script'
    });
  }

  static sendStepsToServer(userId, token, steps) {
    return $.ajax({
      url: "/health_manager/steps",
      type: 'POST',
      data: {
        steps: {
          user_id: userId,
          token,
          steps
        }
      },
      headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
      },
      cache: false,
      dataType: 'script'
    });
  }

  static sendWorkoutsToServer(userId, token, workouts, deletedWorkouts, anchor) {
    return $.ajax({
      url: "/health_manager/workouts",
      type: 'POST',
      data: {
        workouts: {
          user_id: userId,
          token,
          workouts,
          deleted_workouts: deletedWorkouts,
          anchor
        }
      },
      headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
      },
      cache: false,
      dataType: 'script'
    });
  }
};
